module.exports = __webpack_public_path__ + "static/me-2ae25b6c04b9a7c96dcd7eba3854b5d9.jpg";